var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"container pt-3 m-auto text-left"},[_c('h1',[_vm._v("Editar Curso")]),_c('h2',[_vm._v("Aún no se ha construido esta funcionalidad")])])])
}]

export { render, staticRenderFns }